import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import LiveCarouselSection from 'screens/Live/components/LiveCarouselSection';
import { COLLECTION_THUMBNAIL_IMAGE, renderImage } from 'helpers/ImageHelper';
import { PANEL_TYPE_LISTING } from 'screens/Live/LiveHelpers';
import { getSegmentLiveCollectionCount } from '@foxcorp/delta-web-analytics';

import Divider from 'components/Divider';

import Style from './LiveCollections.module.scss';

const LiveCollections = ({ accessToken, breakpoint, favoritesManager, panels }) => {
  const imageRender = useCallback(
    image =>
      renderImage({
        breakpoint,
        imageType: COLLECTION_THUMBNAIL_IMAGE,
        ...image,
      }),
    [],
  );
  const collectionVerticalPosition = useRef(0);
  const collectionCount = getSegmentLiveCollectionCount(panels);

  const epgCollections = panels?.member?.map((panel, idx) => {
    const panelType = _.get(panel, 'panelType');
    if (panelType === PANEL_TYPE_LISTING) {
      collectionVerticalPosition.current = 0;
      return null;
    }

    collectionVerticalPosition.current += 1;

    return (
      <LiveCarouselSection
        accessToken={accessToken}
        breakpoint={breakpoint}
        collectionCount={collectionCount}
        collectionVerticalPosition={collectionVerticalPosition.current}
        dropdownHeadline={panel?.headline}
        epgItems={panel?.items?.member}
        favoritesManager={favoritesManager}
        key={`${panel.headline}-carousel`}
        panel={panels}
        renderImage={imageRender}
        Style={Style}
      />
    );
  });

  if (!panels?.member) return null;

  return (
    <div className={Style.collectionsContainer}>
      <Divider Style={Style} />
      {epgCollections}
    </div>
  );
};

LiveCollections.propTypes = {
  accessToken: PropTypes.string,
  breakpoint: PropTypes.string,
  favoritesManager: PropTypes.shape({}),
  panels: PropTypes.shape({}),
};

export default React.memo(LiveCollections);
